import styled from "@emotion/styled";
import { HtmlReactParser } from "@kaltura/mediaspace-shared-utils";
import { CategorySectionProps } from "@kaltura/mediaspace-shared-types";
import { generalHtmlStyles } from "@kaltura/mediaspace-shared-ui";
import { Typography } from "@kaltura/ds-react-components";

export type AboutSectionProps = CategorySectionProps<string>;

const StyledAboutSection = styled("div")(({ theme }) => [
    {
        width: "100%",
        [theme.breakpoints.up("sm")]: {
            width: 552,
        },
        [theme.breakpoints.up("md")]: {
            width: 680,
        },
    },
    generalHtmlStyles(theme),
]);

/**
 * Category page about section
 */
export function AboutSection(props: AboutSectionProps) {
    return (
        <StyledAboutSection className={"kms-ds-channel-page-section-about"}>
            <Typography variant={"body1"} component={"div"}>
                {HtmlReactParser(props.content)}
            </Typography>
        </StyledAboutSection>
    );
}
AboutSection.displayName = "AboutSection";

export default AboutSection;
